/**
 * Renders HTML content in .ingredienti-html elements (e.g. ingredienti with strong tags).
 * Decodes HTML entities from data-ingredienti and sets innerHTML.
 */
function renderIngredientiHtml() {
  document.querySelectorAll('.ingredienti-html').forEach((el) => {
    const raw = el.dataset.ingredienti;
    if (!raw) return;
    const div = document.createElement('div');
    div.innerHTML = raw;
    el.innerHTML = div.innerHTML;
    el.removeAttribute('data-ingredienti');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderIngredientiHtml);
} else {
  renderIngredientiHtml();
}

const observer = new MutationObserver(() => renderIngredientiHtml());

['CartDrawer-CartItems', 'main-cart-items', 'cart-notification-product', 'cart-notification'].forEach((id) => {
  const el = document.getElementById(id);
  if (el) observer.observe(el, { childList: true, subtree: true });
});
